import { isNil } from "@etudescarre/utils";
import { FilePdf as FilePdfIcon } from "@phosphor-icons/react";
import { useOpenFichier } from "./use-open-fichier";

export type ClasseurPdfButtonProps = {
  fichierId: number | null;
  /** What the file is, for screen readers: « le rapport RE-CT-01 ». */
  label: string;
};

export function ClasseurPdfButton({
  fichierId,
  label,
}: ClasseurPdfButtonProps) {
  const openFichier = useOpenFichier();

  if (isNil(fichierId)) return <span className="text-zinc-300">-</span>;
  return (
    <button
      type="button"
      aria-label={`Ouvrir ${label}`}
      title={`Ouvrir ${label}`}
      className="text-red-600 hover:text-red-700"
      onClick={(event) => {
        event.stopPropagation();
        openFichier(fichierId);
      }}
    >
      <FilePdfIcon size={18} />
    </button>
  );
}
